import React, { useRef } from "react";
import { Loader } from "semantic-ui-react";

import { useGetFeedbackLogsQuery } from "./FeedbackApiSlice";

const FeedbackLog = (props) => {
  const messageRef = useRef(null);

  const {
    data: feedbackLog,
    isLoading,
    isError,
    error,
  } = useGetFeedbackLogsQuery({session: props.feedback_session_id});

  if (isLoading) {
    return <Loader active />;
  }

  if (isError) return null;

  let content;
  content = (
    <div ref={messageRef}>
      {feedbackLog.results.map((message, index) => (
        <div id={message.id} className={`message-row ${message.speaker === "H" ? "sent" : "received"}`}>
          <div className={`message-bubble ${message.speaker === "H" ? "sent" : "received"}`}>
            <p className="message-text">{message.edited_utterance}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return content;
};

export default FeedbackLog;
